/* eslint-disable no-console */

let enabled = false;
const PREFIX = '[websdk]';

export function setDebug(value: boolean): void {
  enabled = value;
}

export const log = {
  debug(...args: unknown[]): void {
    if (enabled) console.debug(PREFIX, ...args);
  },
  info(...args: unknown[]): void {
    if (enabled) console.info(PREFIX, ...args);
  },
  warn(...args: unknown[]): void {
    if (enabled) console.warn(PREFIX, ...args);
  },
  error(...args: unknown[]): void {
    console.error(PREFIX, ...args);
  },
};
